import React, { useEffect, useState } from "react";
import EmployeePerformanceTable from "./components/employeePerTable";
import { Box, Pagination, Grid, useMediaQuery, useTheme } from "@mui/material";
import EmployeePerformCard from "./components/employeePerformCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeePerformanceOverview } from "../../store/reducers/employeePerformanceOverview";

const columns = [
  { id: "employee", label: "Employee" },
  { id: "readings", label: "Readings" },
  { id: "total_points", label: "Points Achieved" },
  { id: "trainings", label: "Micro Trainings" },
  { id: "badges", label: "Badges Earned" },
  { id: "view", label: "View" },
];


const EmployeePerformance = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = useState(1);
  const organizationId = localStorage.getItem("organisation_id");
  const dispatch = useDispatch()
  const { data, loading, error } = useSelector(
    (state) => state.employeePerformanceOverview
  );
  const itemsPerPage = 10;
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const paginatedRows = data.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchEmployeePerformanceOverview(+organizationId));
    }
  }, [organizationId, dispatch]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <div
      style={{ marginTop: "1rem", paddingBottom: `${isMobile ? "1rem" : ""}` }}
    >
      <div
        style={{
          padding: isMobile ? "0" : "2rem",
          backgroundColor: isMobile ? "transparent" : "#FFF0F1",
          borderRadius: isMobile ? "0" : "16px",
          minHeight: isMobile ? "" : "90vh",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            color: "#2B2B2B",
            marginBottom: isMobile ? "1rem" : "2rem",
            fontSize: isMobile ? "18px" : "24px",
          }}
        >
          Employee Performance Overview
        </h3>

        {isMobile ? (
          <div>
            <Grid container spacing={1}>
              {paginatedRows.map((employee, index) => (
                <Grid item xs={12} key={employee.id}>
                  {loading ? <Box
                    height="64vh"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <div className="spinner-border text-danger" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </Box> : <EmployeePerformCard
                    data={employee}
                    index={(page - 1) * itemsPerPage + index}
                    loading={loading}
                    onClick={() => window.location.href = `/employee-progress/${employee.id}`}
                  />}
                </Grid>
              ))}
            </Grid>

            {data.length > 10 && (
              <Box mt={2} display="flex" justifyContent="center">
                <Pagination
                  count={pageCount}
                  page={page}
                  onChange={handleChangePage}
                  shape="rounded"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#F6605F !important",
                      color: "#fff !important",
                      "&:hover": {
                        backgroundColor: "#F6605F !important",
                      },
                    },
                  }}
                />
              </Box>
            )}
          </div>
        ) : (
          <EmployeePerformanceTable columns={columns} rows={data} loading={loading} />
        )}
      </div>
    </div>
  );
};
export default EmployeePerformance;
